import gql from 'graphql-tag';

export const CREATE_GOOGLE_RESERVE_APP = gql`
  mutation createGoogleReserveApp($input: CreateGoogleReserveAppInput!) {
    createGoogleReserveApp(input: $input) {
      googleReserveApp {
        id
      }
    }
  }
`;

export const GET_PLACE_INFO = gql`
  query getPlaceInfo {
    placeInfo {
      name
      placeId
      rating
      types
      url
      website
    }
  }
`;

export const GET_MICRO_SITE = gql`
  query getMicroSite {
    microSite {
      gaId
      id
      url
    }
  }
`;

export const GET_WEBSITE = gql`
  query getWebsite {
    website {
      status
      url
      notes
      termsAcceptedAt
      termsVersion
      cancellationRequestedAt
      reactivationRequestedAt
      publishedAt
      giftcardWidgetEnabled
      createdAt
    }
  }
`;

export const UPDATE_WEBSITE = gql`
  mutation updateWebsite($input: UpdateWebsiteInput!) {
    updateWebsite(input: $input) {
      website {
        giftcardWidgetEnabled
      }
      errors {
        message
      }
    }
  }
`;

export const CREATE_WEBSITE = gql`
  mutation createWebsite($input: CreateWebsiteInput!) {
    createWebsite(input: $input) {
      website {
        status
        url
        notes
        termsAcceptedAt
        cancellationRequestedAt
        publishedAt
        giftcardWidgetEnabled
        createdAt
      }
    }
  }
`;

export const ACCEPT_WEBSITE_TERMS = gql`
  mutation acceptWebsiteTerms($input: AcceptWebsiteTermsInput!) {
    acceptWebsiteTerms(input: $input) {
      website {
        termsAcceptedAt
        termsVersion
      }
    }
  }
`;

export const REQUEST_WEBSITE_CANCELLATION = gql`
  mutation requestWebsiteCancellation($input: RequestWebsiteCancellationInput!) {
    requestWebsiteCancellation(input: $input) {
      website {
        cancellationRequestedAt
        cancellationReason
        cancellationExplanation
      }
    }
  }
`;

export const REQUEST_WEBSITE_REACTIVATION = gql`
  mutation requestWebsiteReactivation($input: RequestWebsiteReactivationInput!) {
    requestWebsiteReactivation(input: $input) {
      website {
        reactivationRequestedAt
      }
    }
  }
`;

export const GET_WEBSITE_PRICE = gql`
  query getWebsitePrice {
    wavyWebsiteExtensionPrice {
      currency
      price
      period
    }
  }
`;
